module.exports = __webpack_public_path__ + "static/backyard-nav-square-9855d86e1519a6554f442973b2346603.jpeg";